import { useState } from "react";

export const faqs = [
  {
    q: "Where can I get an emergency passport in Gainesville today?",
    a: "Fast Passport Center provides emergency passport processing for Gainesville travelers — as fast as 24 hours depending on eligibility. There is no regional passport agency in Gainesville itself. The closest agency is the Miami Passport Agency at 1501 Biscayne Blvd Suite 210, Miami, FL 33132, approximately 330 miles away, about 5 hours via I-75. The Atlanta Passport Agency is about 430 miles away. Both agencies serve documented life-or-death emergencies by appointment only — neither is available for standard expedited requests. Fast Passport Center's registered courier service provides the fastest accessible alternative without the long drive.",
  },
  {
    q: "What is the fastest way to get a passport in Gainesville?",
    a: "The fastest way to get a passport in Gainesville is through a registered U.S. Department of State passport courier like Fast Passport Center, which can process passports in as fast as 2–9 business days for standard expedited service, or as fast as 24 hours for emergency-eligible cases. Self-service at a Gainesville post office or acceptance facility typically takes 2–6 months — not viable for urgent travel. Regional passport agencies only handle life-or-death emergencies with proof of travel.",
  },
  {
    q: "Can I get a same-day passport in Gainesville?",
    a: "Same-day passport issuance is only available through a regional passport agency — and only for documented life-or-death emergencies with proof of imminent international travel. The closest agencies to Gainesville are the Miami Passport Agency at 1501 Biscayne Blvd Suite 210, Miami, FL 33132 (330 miles) and the Atlanta Passport Agency (430 miles). You must secure an NPIC appointment before traveling, and walk-ins are never accepted. For non-emergency situations, Fast Passport Center's fastest courier processing (as fast as 24 hours) is the best available option.",
  },
  {
    q: "Is there a passport agency in Gainesville?",
    a: "No, there is no regional passport agency in Gainesville. The closest regional passport agencies are the Miami Passport Agency at 1501 Biscayne Blvd Suite 210, Miami, FL 33132 — approximately 330 miles from Gainesville, about 5 hours via I-75 — and the Atlanta Passport Agency at 230 Peachtree St NW Suite 1000, Atlanta, GA 30303 — approximately 430 miles. Both agencies only serve documented life-or-death emergencies by appointment. For all other expedited passport needs, Fast Passport Center's registered courier service is the fastest accessible option for Gainesville travelers without the long drive.",
  },
  {
    q: "What if I can't get a Gainesville passport agency appointment?",
    a: "Since there is no passport agency in Gainesville, the nearest options are the Miami Passport Agency (330 miles) and Atlanta Passport Agency (430 miles) — where appointments are typically booked 2–4 weeks in advance and walk-ins are never accepted. If you cannot secure an appointment or your travel is sooner, Fast Passport Center's registered courier service submits directly through reserved agency slots without you needing an appointment or the long drive. Most Gainesville travelers start online and ship documents overnight — much faster than waiting for an agency appointment to open up.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order.",
  },
  {
    q: "Can I get an expedited passport if I've never had one before?",
    a: "Yes, but first-time applicants typically require an in-person acceptance clerk visit before documents can be submitted for expedited processing. We guide you through exactly what to do and where to go in the Gainesville area.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
  {
    q: "What if I need a child passport in Gainesville?",
    a: "Child passports (for minors 15 and under) require parental participation and an in-person acceptance step — both parents typically must consent. We provide clear instructions and a checklist so you know exactly what to do at a Gainesville acceptance facility. Expedited processing options are available after the acceptance step.",
  },
];

export default function GainesvilleFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Gainesville travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}